const io = require('socket.io-client');
const feathers = require('@feathersjs/feathers');
const socketio = require('@feathersjs/socketio-client');
const auth = require('@feathersjs/authentication-client');

export const EXCHANGE_API = process.env.REACT_APP_EXCHANGE_API;
export const TICKER_API = process.env.REACT_APP_TICKER_API;
export const CRM = process.env.REACT_APP_CRM;

export const API_URL = process.env.REACT_APP_TICKER_API;
export const STORAGE_URL = process.env.REACT_APP_STORAGE_API;
export const AVATAR_URL = process.env.REACT_APP_AVATARURL;
export const IMAGE_URL = process.env.REACT_APP_IMAGEURL;
export const TRADINGBRIDGE = process.env.REACT_APP_TRADING_API;
export const BROKERID = process.env.REACT_APP_BROKER_ID;
export const EMAIL_API = process.env.REACT_APP_EMAIL_API;
export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const BROKER_LOGO = process.env.REACT_APP_LOGO;
export const BROKER_BG = process.env.REACT_APP_BG;
export const BROKER_NAME = process.env.REACT_APP_BROKERNAME;
export const BROKER_SHORT = process.env.REACT_APP_BROKERSHORT;

export const BROKER_EMAIL = process.env.REACT_APP_BROKER_EMAIL;
export const BROKER_EMAIL_LOGO = process.env.REACT_APP_EMAIL_LOGO;
export const BROKER_EMAIL_MASTHEAD = process.env.REACT_APP_EMAIL_MASTHEAD;

export const EMAIL_METHOD = process.env.REACT_APP_EMAIL_METHOD;

export const ENABLED_CURRENCIES = JSON.parse(process.env.REACT_APP_CURRENCIES);
export const ENABLED_LANGUAGES = JSON.parse(process.env.REACT_APP_LANGUAGES);

export const CREDIT_CARD_DEPOSIT = 'cxpay';
export const CXPAY_URL = 'https://de.earlybirdfunding.com/CXAPM.php';

let agents = false;

try {
    agents = JSON.parse(process.env.REACT_APP_AGENTS);
} catch (e){
    agents = false;
}

export const AGENTS = agents;

const socket = io(EXCHANGE_API);

const app = feathers();
app.configure(auth({
    strategy: 'jwt',
    storage: window.localStorage
}));
app.configure(socketio(socket, {timeout:40000}));

export const API = app;
export const SOCKET = socket;

export async function reAuth() {
    new Promise(function (resolve, reject) {
        if(window.localStorage.getItem('feathers-jwt')) {
            app.authenticate({
                strategy: 'jwt',
                accessToken: window.localStorage.getItem('feathers-jwt')
            }).then((response)=>{
                app.passport.verifyJWT(response.accessToken).then((data)=>{
                    app.service('investors').get(data.investorsId).then((u)=>{
                        resolve(u);
                    });
                })
            }).catch((e)=>{
                reject(Error("Not Authenticated"));
            })
        } else {
            reject(Error("Not Authenticated"));
        }
    })
};

export function populateRole(userType){
    return '';
    //return JSON.parse(userType);
}

export function CONSOLE(output){
    if(process.env.NODE_ENV !== 'production'){
        console.log(output)
    }
}
